import RadarContext, { toLegacyApiTimeFormat } from "../contexts/RadarContext";
import { useContext, useEffect } from "react";

import { TileLayer } from "react-leaflet";

export interface RadarLayerLegacyProps {
  opacity: number;
}

const RadarLayerLegacy = ({ opacity }: RadarLayerLegacyProps) => {
  const radar = useContext(RadarContext);

  // Legacy layer loads all frames at once — mark as fully loaded immediately
  useEffect(() => {
    if (radar?.legacyInfo) {
      radar.setFramesLoaded(radar.framesTotal);
    }
  }, [radar?.legacyInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  if (radar?.legacyInfo) {
    const { frame } = radar;
    const { baseURL, nullTile, times } = radar.legacyInfo;
    const layers = times.map((time, i) => (
      <TileLayer
        zIndex={100}
        key={time.toISOString()}
        errorTileUrl={nullTile}
        url={baseURL + "/" + toLegacyApiTimeFormat(time) + "/{z}/{x}/{y}.png"}
        opacity={frame === i ? opacity : 0}
      />
    ));
    return <>{layers}</>;
  } else {
    return <></>;
  }
};

export default RadarLayerLegacy;
